export default "__VITE_ASSET__DHR5094J__"